import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "filtro-section" }
const _hoisted_3 = { class: "opciones-tipo" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "contenedor-tabla" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = {
  key: 1,
  class: "lista-tabla"
}
const _hoisted_8 = { class: "badge" }
const _hoisted_9 = { class: "acciones" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 2,
  class: "mensaje-vacio"
}
const _hoisted_14 = { class: "seccion-escalas" }
const _hoisted_15 = { class: "toggle-icon" }
const _hoisted_16 = {
  key: 0,
  class: "escalas-contenido"
}
const _hoisted_17 = {
  key: 0,
  class: "info"
}
const _hoisted_18 = { class: "escala-header" }
const _hoisted_19 = { class: "escala-nombre" }
const _hoisted_20 = { class: "badge" }
const _hoisted_21 = { class: "lista-tabla" }
const _hoisted_22 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_23 = {
  key: 0,
  class: "botones",
  style: {"margin-bottom":"1.5rem"}
}
const _hoisted_24 = {
  key: 1,
  class: "formulario-crear"
}
const _hoisted_25 = {
  key: 0,
  class: "errores-servidor"
}
const _hoisted_26 = { class: "fila" }
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 0,
  class: "info-asignado"
}
const _hoisted_29 = { class: "fila" }
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 0,
  class: "info-asignado"
}
const _hoisted_32 = {
  key: 1,
  class: "niveles-section"
}
const _hoisted_33 = { class: "fila" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "nivel-header" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "nivel-grid" }
const _hoisted_39 = { class: "campo" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { class: "campo" }
const _hoisted_42 = { class: "rango-doble" }
const _hoisted_43 = ["onUpdate:modelValue", "max"]
const _hoisted_44 = ["onUpdate:modelValue", "max"]
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 0,
  class: "mensaje-vacio"
}
const _hoisted_47 = {
  key: 2,
  class: "niveles-section"
}
const _hoisted_48 = { class: "niveles-header" }
const _hoisted_49 = { class: "nivel-header" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "nivel-grid" }
const _hoisted_52 = { class: "campo" }
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "campo" }
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = { class: "campo" }
const _hoisted_57 = ["onUpdate:modelValue", "max"]
const _hoisted_58 = { class: "campo" }
const _hoisted_59 = ["onUpdate:modelValue", "max"]
const _hoisted_60 = { class: "campo campo-full" }
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = {
  key: 0,
  class: "mensaje-vacio"
}
const _hoisted_63 = {
  key: 3,
  class: "niveles-section"
}
const _hoisted_64 = { class: "nivel-header" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "nivel-grid" }
const _hoisted_67 = { class: "campo" }
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = { class: "campo" }
const _hoisted_70 = ["onUpdate:modelValue"]
const _hoisted_71 = { class: "campo" }
const _hoisted_72 = ["onUpdate:modelValue"]
const _hoisted_73 = { class: "campo" }
const _hoisted_74 = ["onUpdate:modelValue"]
const _hoisted_75 = { class: "nivel-card" }
const _hoisted_76 = { class: "nivel-grid" }
const _hoisted_77 = { class: "campo" }
const _hoisted_78 = { class: "campo" }
const _hoisted_79 = { class: "nivel-header" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "nivel-grid" }
const _hoisted_82 = { class: "campo" }
const _hoisted_83 = ["onUpdate:modelValue"]
const _hoisted_84 = { class: "campo" }
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = { class: "campo" }
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = { class: "campo" }
const _hoisted_89 = { class: "rango-fila" }
const _hoisted_90 = ["onUpdate:modelValue", "max"]
const _hoisted_91 = ["onUpdate:modelValue", "max"]
const _hoisted_92 = { class: "campo" }
const _hoisted_93 = { class: "rango-fila" }
const _hoisted_94 = ["onUpdate:modelValue"]
const _hoisted_95 = ["onUpdate:modelValue"]
const _hoisted_96 = { class: "campo campo-ancho" }
const _hoisted_97 = ["onUpdate:modelValue"]
const _hoisted_98 = {
  key: 0,
  class: "mensaje-vacio"
}
const _hoisted_99 = {
  key: 4,
  class: "mensaje-vacio"
}
const _hoisted_100 = { class: "botones" }
const _hoisted_101 = ["disabled"]

import { ref, reactive, onMounted, watch } from 'vue'
import { useGestionCriterioEvaluacion } from '@/store/GestionCriterioEvaluacion'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { useGestionVersiones } from '@/store/GestionVersiones'
import useModelo from '@/store/GestionModelo'
import useAutenticar from '@/store/IngresoAutenticar'
import type {
  CriterioEvaluacion,
  RubricaCriterio,
  RubricaDocumental,
  RubricaCuantitativa,
  RubricaOpinion,
  MuestraOpinion,
  GradoValoracionOpinion,
  TipoInformacion,
  EscalaValoracion
} from '@/interfaces/CriterioEvaluacion'
import { getEscalasValoracionService } from '@/services/CriterioEvaluacionService'
import {
  esRubricaDocumental,
  esRubricaCuantitativa,
  esRubricaOpinion
} from '@/interfaces/CriterioEvaluacion'
import { validarRubrica } from '@/utils/validarRubrica'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import RubricaVisorModal from '@/components/RubricaVisorModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'GestionRubricasView',
  setup(__props) {

/**
 * Definición de rúbricas (escalas de calificación).
 *
 * El formulario es POLIMÓRFICO: documental pide una matriz [grado × criterio],
 * cuantitativa pide niveles con rangos, y opinión pide la tabla de conversión.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/rubricas` (GestionRubricas) — permiso `rubricas.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const store = useGestionCriterioEvaluacion()
const auth = useAutenticar()
const tiposStore = useGestionTipoComponente()
const versionesStore = useGestionVersiones()
const modeloStore = useModelo()
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

const tiposInformacion = ['documental', 'cuantitativa', 'opinion']
const filtroTipo = ref('')
const loading = ref(false)
const mostrarForm = ref(false)
const guardando = ref(false)
const editandoId = ref<number | null>(null)
const showConfirmacion = ref(false)
const idEliminar = ref<number | null>(null)
// Visor de solo lectura de la rúbrica
const visorVisible = ref(false)
const criterioEnVisor = ref<CriterioEvaluacion | null>(null)
const erroresServidor = ref<Record<string, string[]>>({})
const idVersionForm = ref<number | null>(null)
const escalaMax = ref<number>(10)
// Escalas de valoración (tabla `grados`): nota → nivel de cumplimiento.
const escalasValoracion = ref<EscalaValoracion[]>([])
const escalasVisibles = ref(false)
const cargandoEscalas = ref(false)

watch(idVersionForm, async (val) => {
  if (!val) { escalaMax.value = 10; return }
  const version = await versionesStore.getVersionById(val)
  if (version?.id_modelo) {
    const modelo = await modeloStore.getModeloById(version.id_modelo)
    escalaMax.value = modelo?.escala_max ?? 10
  }
})

// C-01 (NC-01): un sub-formulario por tipo de información (rúbrica polimórfica)
const form = ref<{ tipo_informacion: TipoInformacion | ''; id_tipo_componente: number }>({
  tipo_informacion: '',
  id_tipo_componente: 0
})

const formDocumental = reactive<RubricaDocumental>({ criterios: [], grados: [] })
const formCuantitativa = reactive<RubricaCuantitativa>({ niveles: [] })
// En el formulario ambas listas SIEMPRE existen (simplifica la plantilla);
// al construir el payload se omite la que quede vacía, porque en la rúbrica
// muestreo y grados son opcionales por separado.
const formOpinion = reactive<{
  muestreo: MuestraOpinion[]
  grados: GradoValoracionOpinion[]
  conversion: { formula: string; escala: string }
}>({
  muestreo: [],
  grados: [],
  conversion: { formula: '', escala: '' }
})

// Al seleccionar tipo_informacion se resuelve automáticamente el id_tipo_componente.
// La normalización NFD elimina tildes para que "Información" y "Informacion" coincidan.
watch(() => form.value.tipo_informacion, (nuevoTipo) => {
  if (!nuevoTipo) {
    form.value.id_tipo_componente = 0
    return
  }
  const norm = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
  const tipoEncontrado = tiposStore.tipos.find(t => {
    if (!t.nombre) return false
    const n = norm(t.nombre)
    if (nuevoTipo === 'documental')  return n.includes('documental') || n.includes('documento')
    if (nuevoTipo === 'cuantitativa') return n.includes('cuantitativ') || n.includes('estadistic')
    if (nuevoTipo === 'opinion')     return n.includes('opinion') || n.includes('encuesta')
    return false
  })
  form.value.id_tipo_componente = tipoEncontrado?.id_tipo_componente ?? 0
})

function limpiarSubformularios() {
  formDocumental.criterios = []
  formDocumental.grados = []
  formCuantitativa.niveles = []
  formOpinion.muestreo = []
  formOpinion.grados = []
  formOpinion.conversion = { formula: '', escala: '' }
}

function rubricaActual(): RubricaCriterio {
  switch (form.value.tipo_informacion) {
    case 'documental':
      return { criterios: [...formDocumental.criterios], grados: formDocumental.grados.map(g => ({ ...g, descriptores: { ...g.descriptores } })) }
    case 'opinion': {
      // Se omite la lista vacía: enviar muestreo:[] haría fallar la validación
      // de "al menos uno de muestreo o grados" por el lado equivocado.
      const opinion: RubricaOpinion = { conversion: { ...formOpinion.conversion } }
      if (formOpinion.muestreo.length) opinion.muestreo = formOpinion.muestreo.map(m => ({ ...m }))
      if (formOpinion.grados.length) opinion.grados = formOpinion.grados.map(g => ({ ...g }))
      return opinion
    }
    default:
      return { niveles: formCuantitativa.niveles.map(n => ({ ...n })) }
  }
}

/** Resumen legible de la estructura según el tipo (columna de la tabla). */
function resumenRubrica(ce: CriterioEvaluacion): string {
  const r = ce.criterio
  if (!r) return '—'
  if (esRubricaDocumental(r)) return `${r.criterios?.length ?? 0} criterios × ${r.grados?.length ?? 0} grados`
  if (esRubricaOpinion(r)) {
    const partes = []
    if (r.muestreo?.length) partes.push(`${r.muestreo.length} grupos de muestreo`)
    if (r.grados?.length) partes.push(`${r.grados.length} grados de valoración`)
    return partes.length ? partes.join(' · ') : '—'
  }
  if (esRubricaCuantitativa(r)) return `${r.niveles?.length ?? 0} niveles`
  return '—'
}

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'positivo') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

function nombreTipoComponente(id: number): string {
  return tiposStore.tipos.find(t => t.id_tipo_componente === id)?.nombre ?? `ID ${id}`
}

function nombreVersion(id: number | null | undefined): string {
  if (!id) return 'General'
  return versionesStore.versiones.find((v: any) => v.id_version === id)?.nombre ?? `Ver. ${id}`
}

async function cargarDatos() {
  loading.value = true
  try {
    await store.cargarTodos(filtroTipo.value || undefined)
  } finally {
    loading.value = false
  }
}

async function cargarEscalasValoracion() {
  cargandoEscalas.value = true
  try {
    escalasValoracion.value = await getEscalasValoracionService()
  } finally {
    cargandoEscalas.value = false
  }
}

function abrirFormulario() {
  editandoId.value = null
  form.value = { tipo_informacion: '', id_tipo_componente: 0 }
  idVersionForm.value = null
  escalaMax.value = 10
  limpiarSubformularios()
  erroresServidor.value = {}
  mostrarForm.value = true
}

function editarCriterio(ce: CriterioEvaluacion) {
  editandoId.value = ce.id ?? null
  form.value = {
    tipo_informacion: ce.tipo_informacion,
    id_tipo_componente: ce.id_tipo_componente
  }
  idVersionForm.value = ce.id_version ?? null
  limpiarSubformularios()

  const r = ce.criterio
  if (r && esRubricaDocumental(r)) {
    formDocumental.criterios = [...(r.criterios ?? [])]
    formDocumental.grados = (r.grados ?? []).map(g => ({ ...g, descriptores: { ...(g.descriptores ?? {}) } }))
  } else if (r && esRubricaOpinion(r)) {
    formOpinion.muestreo = (r.muestreo ?? []).map(m => ({ ...m }))
    formOpinion.grados = (r.grados ?? []).map(g => ({ ...g }))
    formOpinion.conversion = { ...(r.conversion ?? { formula: '', escala: '' }) }
  } else if (r && esRubricaCuantitativa(r)) {
    formCuantitativa.niveles = (r.niveles ?? []).map(n => ({ ...n }))
  }

  erroresServidor.value = {}
  mostrarForm.value = true
}

function cerrarFormulario() {
  mostrarForm.value = false
  editandoId.value = null
  erroresServidor.value = {}
}

function agregarCriterioDoc() {
  formDocumental.criterios.push('')
}

function eliminarCriterioDoc(i: number) {
  const nombre = formDocumental.criterios[i]
  formDocumental.criterios.splice(i, 1)
  formDocumental.grados.forEach(g => { delete g.descriptores[nombre] })
}

function agregarGradoDoc() {
  formDocumental.grados.push({ grado: '', rango_min: 0, rango_max: 0, descriptores: {} })
}

function agregarNivelCuant() {
  formCuantitativa.niveles.push({ grado: '', tendencia: '', rango_min: 0, rango_max: 0, descripcion: '' })
}

function agregarGradoValoracion() {
  formOpinion.grados.push({
    grado: '', grado_valoracion: '', valoracion: '',
    rango_min: 0, rango_max: 0, pct_min: null, pct_max: null, juicio_de_valor: ''
  })
}

function agregarMuestra() {
  formOpinion.muestreo.push({ grupo_interes: '', tipo_muestreo: '', criterios: '', tecnica: '' })
}

async function guardar() {
  erroresServidor.value = {}
  if (!form.value.id_tipo_componente) {
    mostrarMensaje('Seleccione el tipo de información para continuar.', 'error')
    return
  }
  const criterio = rubricaActual()
  const errorLocal = validarRubrica(form.value.tipo_informacion, criterio)
  if (errorLocal) {
    mostrarMensaje(errorLocal, 'error')
    return
  }

  guardando.value = true
  try {
    const payload = {
      tipo_informacion: form.value.tipo_informacion as TipoInformacion,
      id_tipo_componente: form.value.id_tipo_componente,
      criterio,
      id_version: idVersionForm.value ?? null
    }

    let result
    if (editandoId.value) {
      result = await store.actualizar(editandoId.value, payload)
    } else {
      result = await store.crear(payload)
    }

    if (result.ok) {
      mostrarMensaje(editandoId.value ? 'Criterio actualizado.' : 'Criterio creado exitosamente.')
      cerrarFormulario()
      await cargarDatos()
    } else {
      if (result.errors) erroresServidor.value = result.errors
      const firstError = result.errors ? Object.values(result.errors).flat()[0] : null
      mostrarMensaje(firstError || 'Error al guardar. Revise los campos.', 'error')
    }
  } finally {
    guardando.value = false
  }
}

function abrirVisor(ce: CriterioEvaluacion) {
  criterioEnVisor.value = ce
  visorVisible.value = true
}

function confirmarEliminar(id: number) {
  idEliminar.value = id
  showConfirmacion.value = true
}

async function ejecutarEliminar() {
  showConfirmacion.value = false
  if (!idEliminar.value) return
  const result = await store.eliminar(idEliminar.value)
  if (result.ok) {
    mostrarMensaje('Criterio eliminado.')
    await cargarDatos()
  } else {
    const firstError = result.errors ? Object.values(result.errors).flat()[0] : null
    mostrarMensaje(firstError || 'Error al eliminar.', 'error')
  }
  idEliminar.value = null
}

onMounted(async () => {
  await tiposStore.getTipos()
  await versionesStore.getVersiones()
  await cargarDatos()
  await cargarEscalasValoracion()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "header-flex" }, [
      _createElementVNode("h1", null, "Gestión de Rúbricas (Criterios de Evaluación)")
    ], -1)),
    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("label", null, "Filtrar por tipo de información", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tiposInformacion, (tipo) => {
          return _createElementVNode("button", {
            key: tipo,
            class: _normalizeClass(["btn opcion", { activo: filtroTipo.value === tipo }]),
            onClick: ($event: any) => {filtroTipo.value = tipo; cargarDatos()}
          }, _toDisplayString(tipo), 11, _hoisted_4)
        }), 64)),
        _createElementVNode("button", {
          class: _normalizeClass(["btn opcion", { activo: filtroTipo.value === '' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => {filtroTipo.value = ''; cargarDatos()})
        }, " Todos ", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Cargando criterios de evaluación..."))
        : (_unref(store).criteriosEvaluacion.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "ID"),
                  _createElementVNode("th", null, "Versión"),
                  _createElementVNode("th", null, "Tipo Información"),
                  _createElementVNode("th", null, "Tipo Componente"),
                  _createElementVNode("th", null, "Estructura"),
                  _createElementVNode("th", null, "Acciones")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).criteriosEvaluacion, (ce) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: ce.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(ce.id), 1),
                    _createElementVNode("td", null, _toDisplayString(nombreVersion(ce.id_version)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(ce.tipo_informacion), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(nombreTipoComponente(ce.id_tipo_componente)), 1),
                    _createElementVNode("td", null, _toDisplayString(resumenRubrica(ce)), 1),
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-ver",
                        onClick: ($event: any) => (abrirVisor(ce))
                      }, "Ver", 8, _hoisted_10),
                      (_unref(auth).tienePermiso('rubricas.editar'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-sm guardar",
                            onClick: ($event: any) => (editarCriterio(ce))
                          }, "Editar", 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      (_unref(auth).tienePermiso('rubricas.eliminar'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-sm salir",
                            onClick: ($event: any) => (confirmarEliminar(ce.id!))
                          }, "Eliminar", 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_13, "No hay criterios de evaluación registrados."))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        type: "button",
        class: "toggle-escalas",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (escalasVisibles.value = !escalasVisibles.value))
      }, [
        _createElementVNode("span", null, "Escalas de valoración (" + _toDisplayString(escalasValoracion.value.length) + ")", 1),
        _createElementVNode("span", _hoisted_15, _toDisplayString(escalasVisibles.value ? '▲' : '▼'), 1)
      ]),
      (escalasVisibles.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "escalas-ayuda" }, " Traducen la calificación obtenida al nivel de cumplimiento. El límite inferior es inclusivo: en la escala 1–10, un 8.20 todavía es «alto grado» y un 8.21 ya es «plenamente». ", -1)),
            (cargandoEscalas.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Cargando escalas de valoración..."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(escalasValoracion.value, (esc) => {
              return (_openBlock(), _createElementBlock("div", {
                key: esc.id_modelo ?? 'defecto',
                class: "escala-bloque"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(esc.modelo ?? `Modelo ${esc.id_modelo}`), 1),
                  _createElementVNode("span", _hoisted_20, "escala " + _toDisplayString(esc.grados.length ? Math.min(...esc.grados.map(g => Number(g.rango_min))) : 0) + "–" + _toDisplayString(esc.escala_max), 1)
                ]),
                _createElementVNode("table", _hoisted_21, [
                  _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Nivel de cumplimiento"),
                      _createElementVNode("th", null, "Desde"),
                      _createElementVNode("th", null, "Hasta")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(esc.grados, (g) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: g.id_grado ?? g.orden
                      }, [
                        _createElementVNode("td", null, _toDisplayString(g.nombre), 1),
                        _createElementVNode("td", null, _toDisplayString(Number(g.rango_min).toFixed(2)), 1),
                        _createElementVNode("td", null, _toDisplayString(Number(g.rango_max).toFixed(2)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            }), 128)),
            (!cargandoEscalas.value && !escalasValoracion.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_22, " No hay escalas de valoración registradas. "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(auth).tienePermiso('rubricas.crear'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn guardar",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (abrirFormulario()))
          }, "+ Nuevo Criterio de Evaluación")
        ]))
      : _createCommentVNode("", true),
    (mostrarForm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("h3", null, _toDisplayString(editandoId.value ? 'Editar' : 'Nuevo') + " Criterio de Evaluación", 1),
          _cache[44] || (_cache[44] = _createElementVNode("div", { class: "divider" }, null, -1)),
          (Object.keys(erroresServidor.value).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(erroresServidor.value, (msgs, campo) => {
                  return (_openBlock(), _createElementBlock("p", { key: campo }, [
                    _createElementVNode("strong", null, _toDisplayString(campo) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(Array.isArray(msgs) ? msgs.join(', ') : msgs), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Versión del modelo (opcional)", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((idVersionForm).value = $event)),
              class: "form-control"
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "— General (sin versión) —", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionesStore).versiones, (v) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: v.id_version,
                  value: v.id_version
                }, _toDisplayString(v.nombre), 9, _hoisted_27))
              }), 128))
            ], 512), [
              [_vModelSelect, idVersionForm.value]
            ]),
            (idVersionForm.value)
              ? (_openBlock(), _createElementBlock("small", _hoisted_28, "Escala máxima: " + _toDisplayString(escalaMax.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "Tipo de información *", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.tipo_informacion) = $event)),
              class: "form-control"
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("option", {
                value: "",
                disabled: ""
              }, "Seleccione...", -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tiposInformacion, (t) => {
                return _createElementVNode("option", {
                  key: t,
                  value: t
                }, _toDisplayString(t), 9, _hoisted_30)
              }), 64))
            ], 512), [
              [_vModelSelect, form.value.tipo_informacion]
            ]),
            (form.value.id_tipo_componente)
              ? (_openBlock(), _createElementBlock("small", _hoisted_31, " Componente asignado: " + _toDisplayString(nombreTipoComponente(form.value.id_tipo_componente)), 1))
              : _createCommentVNode("", true)
          ]),
          (form.value.tipo_informacion === 'documental')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", { class: "niveles-header" }, [
                  _cache[18] || (_cache[18] = _createElementVNode("h4", null, "Matriz documental (criterios × grados)", -1)),
                  _createElementVNode("div", { class: "acciones" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm guardar",
                      onClick: agregarCriterioDoc
                    }, "+ Criterio"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm guardar",
                      onClick: agregarGradoDoc
                    }, "+ Grado")
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", null, "Criterios de la matriz (Coherencia, Claridad, Pertinencia, Difusión, Aplicación…)", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formDocumental.criterios, (c, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'crit-' + i,
                      class: "criterio-fila"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((formDocumental.criterios[i]) = $event),
                        class: "form-control",
                        placeholder: "Nombre del criterio"
                      }, null, 8, _hoisted_34), [
                        [_vModelText, formDocumental.criterios[i]]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-eliminar",
                        onClick: ($event: any) => (eliminarCriterioDoc(i))
                      }, "×", 8, _hoisted_35)
                    ]))
                  }), 128))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formDocumental.grados, (grado, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'grado-' + i,
                    class: "nivel-card"
                  }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("strong", null, "Grado " + _toDisplayString(i + 1), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-eliminar",
                        onClick: ($event: any) => (formDocumental.grados.splice(i, 1))
                      }, "Eliminar", 8, _hoisted_37)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", null, "Grado *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((grado.grado) = $event),
                          class: "form-control",
                          placeholder: "Se cumple plenamente"
                        }, null, 8, _hoisted_40), [
                          [_vModelText, grado.grado]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", null, "Banda (mín / máx) *", -1)),
                        _createElementVNode("div", _hoisted_42, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((grado.rango_min) = $event),
                            type: "number",
                            step: "0.01",
                            min: "0",
                            max: escalaMax.value,
                            class: "form-control"
                          }, null, 8, _hoisted_43), [
                            [
                              _vModelText,
                              grado.rango_min,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((grado.rango_max) = $event),
                            type: "number",
                            step: "0.01",
                            min: "0",
                            max: escalaMax.value,
                            class: "form-control"
                          }, null, 8, _hoisted_44), [
                            [
                              _vModelText,
                              grado.rango_max,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formDocumental.criterios, (c) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: c,
                          class: "campo campo-full"
                        }, [
                          _createElementVNode("label", null, "Descriptor — " + _toDisplayString(c || '(criterio sin nombre)') + " *", 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((grado.descriptores[c]) = $event),
                            class: "form-control",
                            placeholder: "Descriptor cualitativo"
                          }, null, 8, _hoisted_45), [
                            [_vModelText, grado.descriptores[c]]
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128)),
                (!formDocumental.grados.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_46, " Agregue al menos un grado a la matriz documental. "))
                  : _createCommentVNode("", true)
              ]))
            : (form.value.tipo_informacion === 'cuantitativa')
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("h4", null, "Niveles cuantitativos (rangos 0–" + _toDisplayString(escalaMax.value) + " con tendencia)", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm guardar",
                      onClick: agregarNivelCuant
                    }, "+ Nivel")
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formCuantitativa.niveles, (nivel, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "nivel-card"
                    }, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("strong", null, "Nivel " + _toDisplayString(i + 1), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-eliminar",
                          onClick: ($event: any) => (formCuantitativa.niveles.splice(i, 1))
                        }, "Eliminar", 8, _hoisted_50)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", null, "Grado *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((nivel.grado) = $event),
                            class: "form-control",
                            placeholder: "Se cumple plenamente"
                          }, null, 8, _hoisted_53), [
                            [_vModelText, nivel.grado]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", null, "Tendencia", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((nivel.tendencia) = $event),
                            class: "form-control",
                            placeholder: "Creciente favorable"
                          }, null, 8, _hoisted_55), [
                            [_vModelText, nivel.tendencia]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", null, "Rango mín *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((nivel.rango_min) = $event),
                            type: "number",
                            step: "0.01",
                            min: "0",
                            max: escalaMax.value,
                            class: "form-control"
                          }, null, 8, _hoisted_57), [
                            [
                              _vModelText,
                              nivel.rango_min,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", null, "Rango máx *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((nivel.rango_max) = $event),
                            type: "number",
                            step: "0.01",
                            min: "0",
                            max: escalaMax.value,
                            class: "form-control"
                          }, null, 8, _hoisted_59), [
                            [
                              _vModelText,
                              nivel.rango_max,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", null, "Descripción", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((nivel.descripcion) = $event),
                            class: "form-control",
                            rows: "2",
                            placeholder: "Descripción del nivel de cumplimiento…"
                          }, null, 8, _hoisted_61), [
                            [_vModelText, nivel.descripcion]
                          ])
                        ])
                      ])
                    ]))
                  }), 128)),
                  (!formCuantitativa.niveles.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_62, " Agregue al menos un nivel para la rúbrica. "))
                    : _createCommentVNode("", true)
                ]))
              : (form.value.tipo_informacion === 'opinion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", { class: "niveles-header" }, [
                      _cache[27] || (_cache[27] = _createElementVNode("h4", null, "Diseño de muestreo por grupo de interés", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm guardar",
                        onClick: agregarMuestra
                      }, "+ Grupo")
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formOpinion.muestreo, (m, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "nivel-card"
                      }, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("strong", null, "Grupo " + _toDisplayString(i + 1), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-eliminar",
                            onClick: ($event: any) => (formOpinion.muestreo.splice(i, 1))
                          }, "Eliminar", 8, _hoisted_65)
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", null, "Grupo de interés *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((m.grupo_interes) = $event),
                              class: "form-control",
                              placeholder: "Estudiantes"
                            }, null, 8, _hoisted_68), [
                              [_vModelText, m.grupo_interes]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _cache[29] || (_cache[29] = _createElementVNode("label", null, "Tipo de muestreo *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((m.tipo_muestreo) = $event),
                              class: "form-control",
                              placeholder: "Aleatorio estratificado"
                            }, null, 8, _hoisted_70), [
                              [_vModelText, m.tipo_muestreo]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _cache[30] || (_cache[30] = _createElementVNode("label", null, "Criterios de selección", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((m.criterios) = $event),
                              class: "form-control",
                              placeholder: "Matriculados 2026-1"
                            }, null, 8, _hoisted_72), [
                              [_vModelText, m.criterios]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _cache[31] || (_cache[31] = _createElementVNode("label", null, "Técnica *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((m.tecnica) = $event),
                              class: "form-control",
                              placeholder: "Encuesta"
                            }, null, 8, _hoisted_74), [
                              [_vModelText, m.tecnica]
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_75, [
                      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "nivel-header" }, [
                        _createElementVNode("strong", null, "Regla de conversión a 0–5")
                      ], -1)),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", null, "Fórmula *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formOpinion.conversion.formula) = $event)),
                            class: "form-control",
                            placeholder: "puntaje_apreciado*100/puntaje_total"
                          }, null, 512), [
                            [_vModelText, formOpinion.conversion.formula]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", null, "Escala *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formOpinion.conversion.escala) = $event)),
                            class: "form-control",
                            placeholder: "porcentaje → 0-5"
                          }, null, 512), [
                            [_vModelText, formOpinion.conversion.escala]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "niveles-header" }, [
                      _cache[35] || (_cache[35] = _createElementVNode("h4", null, "Tabla de valoración", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm guardar",
                        onClick: agregarGradoValoracion
                      }, "+ Fila")
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formOpinion.grados, (g, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'g' + i,
                        class: "nivel-card"
                      }, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("strong", null, _toDisplayString(g.grado || `Fila ${i + 1}`), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-eliminar",
                            onClick: ($event: any) => (formOpinion.grados.splice(i, 1))
                          }, "Eliminar", 8, _hoisted_80)
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _cache[36] || (_cache[36] = _createElementVNode("label", null, "Grado de cumplimiento *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((g.grado) = $event),
                              class: "form-control",
                              placeholder: "Se cumple plenamente"
                            }, null, 8, _hoisted_83), [
                              [_vModelText, g.grado]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            _cache[37] || (_cache[37] = _createElementVNode("label", null, "Grado de valoración", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((g.grado_valoracion) = $event),
                              class: "form-control",
                              placeholder: "Mejoramiento Continuo"
                            }, null, 8, _hoisted_85), [
                              [_vModelText, g.grado_valoracion]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _cache[38] || (_cache[38] = _createElementVNode("label", null, "Valoración", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((g.valoracion) = $event),
                              class: "form-control",
                              placeholder: "Plena o Completa"
                            }, null, 8, _hoisted_87), [
                              [_vModelText, g.valoracion]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _cache[40] || (_cache[40] = _createElementVNode("label", null, "Escala cuantitativa (mín – máx) *", -1)),
                            _createElementVNode("div", _hoisted_89, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((g.rango_min) = $event),
                                type: "number",
                                step: "0.01",
                                min: "0",
                                max: escalaMax.value,
                                class: "form-control",
                                placeholder: "4.5"
                              }, null, 8, _hoisted_90), [
                                [
                                  _vModelText,
                                  g.rango_min,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "rango-sep" }, "–", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((g.rango_max) = $event),
                                type: "number",
                                step: "0.01",
                                min: "0",
                                max: escalaMax.value,
                                class: "form-control",
                                placeholder: "5"
                              }, null, 8, _hoisted_91), [
                                [
                                  _vModelText,
                                  g.rango_max,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _cache[42] || (_cache[42] = _createElementVNode("label", null, "Cumplimiento % (mín – máx)", -1)),
                            _createElementVNode("div", _hoisted_93, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((g.pct_min) = $event),
                                type: "number",
                                step: "1",
                                min: "0",
                                max: "100",
                                class: "form-control",
                                placeholder: "90"
                              }, null, 8, _hoisted_94), [
                                [
                                  _vModelText,
                                  g.pct_min,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[41] || (_cache[41] = _createElementVNode("span", { class: "rango-sep" }, "–", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((g.pct_max) = $event),
                                type: "number",
                                step: "1",
                                min: "0",
                                max: "100",
                                class: "form-control",
                                placeholder: "100"
                              }, null, 8, _hoisted_95), [
                                [
                                  _vModelText,
                                  g.pct_max,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _cache[43] || (_cache[43] = _createElementVNode("label", null, "Juicio de valor", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((g.juicio_de_valor) = $event),
                              class: "form-control",
                              rows: "2",
                              placeholder: "Significa que…"
                            }, null, 8, _hoisted_97), [
                              [_vModelText, g.juicio_de_valor]
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (!formOpinion.muestreo.length && !formOpinion.grados.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_98, " Agregue al menos un grupo de interés al muestreo o una fila a la tabla de valoración. "))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_99, " Seleccione el tipo de información para configurar la rúbrica correspondiente. ")),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("button", {
              class: "btn salir",
              onClick: cerrarFormulario
            }, "Cancelar"),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: guardando.value,
              onClick: guardar
            }, _toDisplayString(guardando.value ? 'Guardando...' : (editandoId.value ? 'Actualizar' : 'Guardar')), 9, _hoisted_101)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(MensajeConfirmacion, {
      visible: showConfirmacion.value,
      title: "Eliminar Criterio de Evaluación",
      message: "¿Está seguro de que desea eliminar este criterio? Esta acción no se puede deshacer.",
      confirmText: "Eliminar",
      cancelText: "Cancelar",
      onConfirm: ejecutarEliminar,
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (showConfirmacion.value = false))
    }, null, 8, ["visible"]),
    _createVNode(RubricaVisorModal, {
      visible: visorVisible.value,
      criterio: criterioEnVisor.value,
      nombreTipoComponente: criterioEnVisor.value ? nombreTipoComponente(criterioEnVisor.value.id_tipo_componente) : '',
      onCerrar: _cache[8] || (_cache[8] = ($event: any) => (visorVisible.value = false))
    }, null, 8, ["visible", "criterio", "nombreTipoComponente"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[9] || (_cache[9] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})